<template>
  <div class="input-field vert-offset-top-0 vert-offset-bottom-half">
    <i v-if="isIcon" class="material-icons prefix">{{ icon }}</i>
    <textarea
      ref="element"
      :id="id"
      v-model="value"
      class="materialize-textarea"
    ></textarea>
    <label :for="id">{{ label }}</label>
  </div>
</template>

<script>
import "materialize-css/dist/js/materialize.min";
//import $ from 'jquery'
import M from "materialize-css";
export default {
  name: "TextAreaComponent",
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String
    },
    id: {
      type: String
    },
    type: {
      type: String
    },
    placeholder: {
      type: String
    },
    icon: {
      type: String,
      default: null
    },
    required: {
      type: String
    },
    helper: {
      type: String
    }
  },
  data() {
    return {
      instance: undefined
    };
  },
  mounted() {
    this.instance = this.$refs.element;
    if (
      typeof this.value !== "undefined" &&
      this.value !== null &&
      this.value.lenght > 0
    )
      M.textareaAutoResize(this.instance);
  },
  computed: {
    isIcon: function() {
      if (
        typeof this.icon === "undefined" ||
        this.icon === null ||
        this.icon == ""
      ) {
        return false;
      }

      return true;
    }
  },
  methods: {}
};
</script>

<style scoped></style>
